# Minimal variant for search/display - no tagTypeName, avoids payload bloat
fragment TagMinimalFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

# Use TagFragmentWithAppliedCount instead
fragment TagFragment on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagFragmentWithAppliedCount on Tag {
  id
  type
  displayValue
  isActive
  attributes
  appliedCount @include(if: $showAppliedCount)
  tagTypeName
  tagAttributesMetaData {
    person {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
    people @include(if: $showTagOwners) {
      aggregateId
      preferredName
      firstName
      surname
      avatar
    }
  }
}

fragment TagPropertyFragment on TagProperty {
  id
  label
  value
  attributeType
  subtype
}

# Minimal fragment for allocation/caching - avoids tagAttributesMetaData payload
fragment EntityTagMinimalFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    isActive
  }
}

fragment EntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  tag {
    id
    displayValue
    type
    attributes
    appliedCount
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}



fragment TagsEditorEntityTagFragment on EntityTag {
  id
  tagId
  type
  replace
  entityId
  entityTagAttributes
  status
  entityType
  tag {
    id
    displayValue
    type
    attributes
    appliedCount @include(if: $includeAppliedCount)
    isActive
    tagAttributesMetaData {
      person {
        aggregateId
        preferredName
        firstName
        surname
        avatar
      }
    }
  }
}
